import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { BoxArrowUpRight, Github, Youtube } from "react-bootstrap-icons";
import MovieMe from "../../assets/movie.png";
import Crime from "../../assets/crime.png";
import FindMy from "../../assets/findmyfilm.png";
import Vanquish from "../../assets/vanquish.png";
import Ecommerce from "../../assets/ecommerce.png";
import Rock from "../../assets/rock.png";
import Todo from "../../assets/Todo.png";
import Pfl from "../../assets/pfl.png";
import Student from "../../assets/student.png";
import Drug from "../../assets/drug.png";
import Business from "../../assets/business.png";
import Raciit from "../../assets/raciit.png";
import Portfolio from "../../assets/portfolio.png";
import Bio from "../../assets/bio.png";
import Cutting from "../../assets/cuttingedge.png";
import Discount from "../../assets/discount.png";
import Ranbath from "../../assets/ranbath.png";
import poppy from "../../assets/poppy.png";
import Babys from "../../assets/babys.png";
import India from "../../assets/india.png";
import "./Projects.css";

const Projects = () => {
    const [showMore, setShowMore] = useState(false);

    const toggleShowMore = () => {
        setShowMore(!showMore)
    }

    return (
        <Container fluid className="project-section" id="projects">
            <h2>
                <span>My </span> Projects
            </h2>
            <Row className="project-row">
                <Col xs={12} md={6} className="project-img order-md-1 order-1">
                    <img src={Crime} alt="website1" />
                </Col>
                <Col xs={12} md={6} className="project-content order-md-2 order-2">
                    <div className="project-desc">
                        <h3>01</h3>
                        <h5>Crime Unfolded</h5>
                        <div className="project-tags">
                            <p>REACTJS</p>
                            <p>HTML</p>
                            <p>CSS</p>
                            <p>EmailJS</p>
                            <p>Dialogflow</p>
                            <p>MaterialUI</p>
                        </div>
                        <p>
                            This project is an official website for a mystery board game. It
                            features a purchasing platform, an AI chatbot for real-time
                            assistance, and an interactive case-solving experience. Users
                            engage by answering questions and solving the mystery, while also
                            having access to helpful resources and community interactions.
                            Dive into the mystery and test your detective skills!
                        </p>
                        <a
                            href="https://crime-unfolded-new.web.app/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <BoxArrowUpRight color="white" size={"30px"} />
                        </a>
                    </div>
                </Col>
            </Row>
            <Row className="project-row">
                <Col xs={12} md={6} className="project-img order-md-2 order-1">
                    <img src={MovieMe} alt="website2" />
                </Col>
                <Col xs={12} md={6} className="project-content order-md-1 order-2">
                    <div className="project-desc">
                        <h3>02</h3>
                        <h5>Find My Film</h5>
                        <div className="project-tags">
                            <p>REACTJS</p>
                            <p>HTML</p>
                            <p>CSS</p>
                            <p>Bootstrap</p>
                        </div>
                        <p>
                            This project is a website for movie enthusiasts to discover and
                            enjoy their favorite films. Built using React, HTML, and CSS, it
                            allows users to browse a curated selection of movies, explore
                            details, and build their own personalized movie lists. The site
                            offers a sleek, responsive design for an engaging and
                            user-friendly experience.
                        </p>
                        <a
                            href="https://findmymovie-b07fd.web.app/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <BoxArrowUpRight color="white" size={"30px"} />
                        </a>
                    </div>
                </Col>
            </Row>
            <Row className="project-row">
                <Col xs={12} md={6} className="project-img order-md-1 order-1">
                    <img src={Vanquish} alt="website1" />
                </Col>
                <Col xs={12} md={6} className="project-content order-md-2 order-2">
                    <div className="project-desc">
                        <h3>03</h3>
                        <h5>Fighting Website</h5>
                        <div className="project-tags">
                            <p>REACTJS</p>
                            <p>HTML</p>
                            <p>CSS</p>
                            <p>Bootstrap</p>
                        </div>
                        <p>
                            This project is a website for a fighting class, designed to
                            showcase their offerings and enable bookings. Although still under
                            construction, it will provide an overview of available classes,
                            instructors, and schedules. Built with a focus on user experience,
                            it aims to facilitate easy class selection and reservation, making
                            it simple for users to get started on their fitness journey.
                        </p>
                        <a
                            href="https://vanquish-c5831.web.app/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <BoxArrowUpRight color="white" size={"30px"} />
                        </a>
                    </div>
                </Col>
            </Row>
            <Row className="project-row">
                <Col className="project-img order-md-2 order-1">
                    <img src={FindMy} alt="website2" />
                </Col>
                <Col className="project-content order-md-1 order-2">
                    <div className="project-desc">
                        <h3>04</h3>
                        <h5>Movie Identification and Genre Prediction with XAI</h5>
                        <div className="project-tags">
                            <p>REACTJS</p>
                            <p>FLASK</p>
                            <p>PYTHON</p>
                            <p>NLP</p>
                            <p>ASR</p>
                            <p>FUZZY LOGICS</p>
                        </div>
                        <p>
                            This project is a sophisticated platform for movie enthusiasts.
                            Users can record audio snippets of unidentified movies to identify
                            them using AI. The application generates genres for each scene and
                            allows users to upload and analyze their scripts. It visualizes
                            genre impacts with XAI, showing how each word influences the
                            genre, enhancing the scriptwriting experience.
                        </p>
                        <a
                            href="https://drive.google.com/file/d/1SJKVV32qWfQ-U9YgwlEiLiBCvN67yeUa/view?usp=drive_link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Youtube color="white" />
                        </a>
                    </div>
                </Col>
            </Row>
            <Row className="project-row">
                <Col xs={12} md={6} className="project-img order-md-1 order-1">
                    <img src={Rock} alt="website1" />
                </Col>
                <Col xs={12} md={6} className="project-content order-md-2 order-2">
                    <div className="project-desc">
                        <h3>05</h3>
                        <h5>Rock, Paper, Scissor Game</h5>
                        <div className="project-tags">
                            <p>REACTJS</p>
                            <p>Flask</p>
                            <p>ViT</p>
                            <p>Computer Vision</p>
                        </div>
                        <p>
                            This project is an online Rock, Paper, Scissors game featuring a
                            computer opponent. Using a vision transformer model, the
                            application identifies your move from a camera feed, while the
                            computer randomly selects its move. The game determines the winner
                            or declares a tie based on classic rules, providing an engaging
                            and interactive gaming experience.
                        </p>
                        <a
                            href="https://drive.google.com/file/d/1Q0GQM-JxbNVXYkPau_Sjn_zHLChDW1zM/view?usp=drive_link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Youtube color="white" size={"30px"} />
                        </a>
                    </div>
                </Col>
            </Row>
            <Row className="project-row">
                <Col className="project-img order-md-2 order-1">
                    <img src={Pfl} alt="website2" />
                </Col>
                <Col className="project-content order-md-1 order-2">
                    <div className="project-desc">
                        <h3>06</h3>
                        <h5>Football Scoreboard</h5>
                        <div className="project-tags">
                            <p>REACTJS</p>
                            <p>HTML</p>
                            <p>CSS</p>
                            <p>Bootstrap</p>
                        </div>
                        <p>
                            This project is a scoreboard application for managing sports clubs
                            and match results. Admins can create clubs, update scores, and
                            maintain a points table that automatically updates with new data.
                            The application also includes a detailed match page, providing a
                            comprehensive view of team performances and standings, ensuring an
                            efficient and streamlined score management process.
                        </p>
                        <a
                            href="https://drive.google.com/file/d/1x6OUjNSh7uJvQauhEEmX4xWpSyx6WFxy/view?usp=drive_link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Youtube color="white" size={"30px"} />
                        </a>
                    </div>
                </Col>
            </Row>
            {showMore && (
                <>

                    <Row className="project-row">
                        <Col xs={12} md={6} className="project-img order-md-1 order-1">
                            <img src={Drug} alt="website1" />
                        </Col>
                        <Col xs={12} md={6} className="project-content order-md-2 order-2">
                            <div className="project-desc">
                                <h3>07</h3>
                                <h5>Drug Prediction</h5>
                                <div className="project-tags">
                                    <p>REACTJS</p>
                                    <p>Flak</p>
                                    <p>Machine Vision</p>
                                    <p>CNN</p>
                                    <p>ViT</p>
                                    <p>Bootstrap</p>
                                </div>
                                <p>
                                    This project is a web application designed to detect drug usage
                                    from an eye image. Users upload an eye image and answer a series
                                    of questions. The system analyzes the image and responses to
                                    determine the likely drug taken. Utilizing advanced image
                                    processing and machine learning, it provides accurate and
                                    insightful conclusions for substance detection.
                                </p>
                                <a
                                    href="https://drive.google.com/file/d/1cL3yPiRJBMbrc_llCp7ySSrm_wdlQqKr/view?usp=drive_link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Youtube color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col className="project-img order-md-2 order-1">
                            <img src={Ecommerce} alt="website2" />
                        </Col>
                        <Col className="project-content order-md-1 order-2">
                            <div className="project-desc">
                                <h3>08</h3>
                                <h5>Mini Ecommerce Website</h5>
                                <div className="project-tags">
                                    <p>MongoDB</p>
                                    <p>Express</p>
                                    <p>REACTJS</p>
                                    <p>Node</p>
                                </div>
                                <p>
                                    This project is a mini e-commerce vendor portal featuring full
                                    CRUD operations. Users can add, update, or delete products, upload
                                    multiple images, and star favorite products. The portal also
                                    includes robust search functionality, enabling users to easily
                                    find products. Designed for efficiency and ease of use, it
                                    provides a seamless experience for managing and discovering
                                    products.
                                </p>
                                <a
                                    href="https://drive.google.com/file/d/1Dyp23NwKfMuanYQI_u6uODZHLEGcZsVm/view?usp=drive_link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Youtube color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col xs={12} md={6} className="project-img order-md-1 order-1">
                            <img src={Student} alt="website1" />
                        </Col>
                        <Col xs={12} md={6} className="project-content order-md-2 order-2">
                            <div className="project-desc">
                                <h3>09</h3>
                                <h5>Student Record Table</h5>
                                <div className="project-tags">
                                    <p>MySQL</p>
                                    <p>Express</p>
                                    <p>REACTJS</p>
                                    <p>Node</p>
                                </div>
                                <p>
                                    This project is a student records management system with full CRUD
                                    operations using MySQL. Users can add, view, edit, and delete
                                    student details efficiently. The application ensures seamless data
                                    handling and provides an intuitive interface for managing student
                                    information. It offers a reliable solution for educational
                                    institutions to maintain accurate and up-to-date student records.
                                </p>
                                <a
                                    href="https://drive.google.com/file/d/1P2Ama5NMplS3c_qJTamRUPcUWhO8Hs6Q/view?usp=drive_link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Youtube color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col className="project-img order-md-2 order-1">
                            <img src={Todo} alt="website2" />
                        </Col>
                        <Col className="project-content order-md-1 order-2">
                            <div className="project-desc">
                                <h3>10</h3>
                                <h5>TO DO LIST</h5>
                                <div className="project-tags">
                                    <p>MongoDB</p>
                                    <p>Express</p>
                                    <p>REACTJS</p>
                                    <p>Node</p>
                                </div>
                                <p>
                                    This project is a to-do list application that allows users to
                                    manage tasks efficiently. Users can add tasks to the list, mark
                                    them as completed, and delete tasks whether completed or not. The
                                    intuitive interface ensures easy task tracking and organization,
                                    helping users stay productive and focused on their goals.
                                </p>
                                <a
                                    href="https://drive.google.com/file/d/1DfdePy1TeIblulBZ1TGdCCP4J5FMXc08/view?usp=drive_link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Youtube color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col xs={12} md={6} className="project-img order-md-1 order-1">
                            <img src={Raciit} alt="website1" />
                        </Col>
                        <Col xs={12} md={6} className="project-content order-md-2 order-2">
                            <div className="project-desc">
                                <h3>11</h3>
                                <h5>Annual Report Site for RACIIT</h5>
                                <div className="project-tags">
                                    <p>HTML</p>
                                    <p>CSS</p>
                                    <p>JavaScript</p>
                                    <p>VantaJS</p>
                                </div>
                                <p>
                                    This project is an annual report for the Rotaract Club of IIT,
                                    created using HTML, CSS, JavaScript, and Vanta.js. The report
                                    showcases the club's activities and achievements in an interactive
                                    and visually engaging format. Leveraging Vanta.js for dynamic
                                    backgrounds, the project provides an immersive experience,
                                    highlighting the club’s impact and milestones throughout the year.
                                </p>
                                <a
                                    href="https://raciit-report.web.app/landing.html"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <BoxArrowUpRight color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col className="project-img order-md-2 order-1">
                            <img src={Business} alt="website2" />
                        </Col>
                        <Col className="project-content order-md-1 order-2">
                            <div className="project-desc">
                                <h3>12</h3>
                                <h5>Business Consultant</h5>
                                <div className="project-tags">
                                    <p>HTML</p>
                                    <p>CSS</p>
                                    <p>JavaScript</p>
                                    <p>Bootstrap</p>
                                </div>
                                <p>
                                    This project is a website for a business consultant agency,
                                    developed using HTML, CSS, JavaScript, and Bootstrap. The site
                                    features a professional and responsive design, showcasing the
                                    agency's services, expertise, and client testimonials. It aims to
                                    provide a seamless user experience, helping potential clients
                                    easily understand and engage with the agency's offerings.
                                </p>
                                <a
                                    href="https://business-consultant-2758d.web.app/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <BoxArrowUpRight color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col xs={12} md={6} className="project-img order-md-1 order-1">
                            <img src={Portfolio} alt="website1" />
                        </Col>
                        <Col xs={12} md={6} className="project-content order-md-2 order-2">
                            <div className="project-desc">
                                <h3>13</h3>
                                <h5>Portfolio Website</h5>
                                <div className="project-tags">
                                    <p>NextJS</p>
                                    <p>HTML</p>
                                    <p>CSS</p>
                                    <p>Tailwind</p>
                                </div>
                                <p>
                                    This project is a personal portfolio website built with Next.js
                                    and Tailwind CSS. It features both dark mode and light mode
                                    options, providing a customizable user experience. The site
                                    showcases my skills, projects, and professional background,
                                    offering a sleek and modern design that adapts to user preferences
                                    for optimal viewing.
                                </p>
                                <a
                                    href="https://my-portfolio-sandun.web.app/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <BoxArrowUpRight color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col className="project-img order-md-2 order-1">
                            <img src={Bio} alt="website2" />
                        </Col>
                        <Col className="project-content order-md-1 order-2">
                            <div className="project-desc">
                                <h3>14</h3>
                                <h5>Project Biodiversity</h5>
                                <div className="project-tags">
                                    <p>Wordpress</p>
                                    <p>Elementor Pro</p>
                                </div>
                                <p>
                                    This project is a biodiversity-focused website dedicated to
                                    environmental cleaning and animal care, built using WordPress and
                                    Elementor. The site provides information on conservation efforts,
                                    volunteer opportunities, and educational resources. It aims to
                                    raise awareness and encourage community involvement in preserving
                                    natural habitats and protecting wildlife.
                                </p>
                                <a
                                    href="hhttps://thebiodiversityproject.org/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <BoxArrowUpRight color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col xs={12} md={6} className="project-img order-md-1 order-1">
                            <img src={Cutting} alt="website1" />
                        </Col>
                        <Col xs={12} md={6} className="project-content order-md-2 order-2">
                            <div className="project-desc">
                                <h3>15</h3>
                                <h5>Cutting-Edge Website</h5>
                                <div className="project-tags">
                                    <p>Wordpress</p>
                                    <p>Elementor</p>
                                    <p>VantaJS</p>
                                </div>
                                <p>
                                    This project is a WordPress website for a hackathon, built with
                                    Elementor and Vanta.js. The site features dynamic backgrounds and
                                    an intuitive interface to showcase event details, rules &
                                    regulations, and registrations. Designed to engage and inform, it
                                    provides a vibrant platform for hackathon participants and
                                    organizers to connect and stay updated.
                                </p>
                                <a
                                    href="https://cuttingedge.iit.ac.lk/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <BoxArrowUpRight color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col className="project-img order-md-2 order-1">
                            <img src={poppy} alt="website2" />
                        </Col>
                        <Col className="project-content order-md-1 order-2">
                            <div className="project-desc">
                                <h3>16</h3>
                                <h5>Poppy Pads Website</h5>
                                <div className="project-tags">
                                    <p>Wordpress</p>
                                    <p>Elementor</p>
                                    <p>E-Commerce</p>
                                </div>
                                <p>
                                    This project is a WordPress website for a business launching
                                    reusable pads, built with Elementor. The site highlights the
                                    benefits of reusable pads, product details, and sustainability
                                    initiatives. It features a clean, user-friendly design to educate
                                    customers, promote eco-friendly products, and encourage
                                    sustainable living.
                                </p>
                                <a
                                    href="https://poppypads.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <BoxArrowUpRight color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col xs={12} md={6} className="project-img order-md-1 order-1">
                            <img src={Ranbath} alt="website1" />
                        </Col>
                        <Col xs={12} md={6} className="project-content order-md-2 order-2">
                            <div className="project-desc">
                                <h3>17</h3>
                                <h5>Ranbath Website</h5>
                                <div className="project-tags">
                                    <p>Wordpress</p>
                                    <p>Elementor Pro</p>
                                </div>
                                <p>
                                    This project is a WordPress website for a restaurant, built with
                                    Elementor. The site showcases the restaurant's menu, location,
                                    hours of operation, and contact details. Designed to be visually
                                    appealing and user-friendly, it provides customers with an easy
                                    way to explore menu options and make reservations.
                                </p>
                                <a
                                    href="https://ranbathorganic.avrinalanka.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <BoxArrowUpRight color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col className="project-img order-md-2 order-1">
                            <img src={Discount} alt="website2" />
                        </Col>
                        <Col className="project-content order-md-1 order-2">
                            <div className="project-desc">
                                <h3>18</h3>
                                <h5>Towing Service Website</h5>
                                <div className="project-tags">
                                    <p>Wordpress</p>
                                    <p>Elementor Pro</p>
                                </div>
                                <p>
                                    This project is a website for a towing service company in the USA,
                                    built with Elementor Pro. The site promotes SEO to attract more
                                    clients, featuring service details, contact information, and
                                    customer testimonials. Designed for optimal search engine
                                    visibility, it aims to increase online presence and drive customer
                                    engagement.
                                </p>
                                <a
                                    href="https://adiscountautotowing.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <BoxArrowUpRight color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col xs={12} md={6} className="project-img order-md-1 order-1">
                            <img src={Babys} alt="website1" />
                        </Col>
                        <Col xs={12} md={6} className="project-content order-md-2 order-2">
                            <div className="project-desc">
                                <h3>19</h3>
                                <h5>Medical Website</h5>
                                <div className="project-tags">
                                    <p>Wordpress</p>
                                    <p>Elementor Pro</p>
                                    <p>E-Commerce</p>
                                    <p>Depictor</p>
                                </div>
                                <p>
                                    This project is a WordPress website for parents and pregnant
                                    mothers to shop for essential baby equipment, built with
                                    Elementor. The site includes a dedicated toy store, offering a
                                    wide range of products. With an intuitive design, it provides a
                                    seamless shopping experience, helping parents find everything they
                                    need for their baby in one place.
                                </p>
                                <a
                                    href="https://babysonbroadway.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <BoxArrowUpRight color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="project-row">
                        <Col className="project-img order-md-2 order-1">
                            <img src={India} alt="website2" />
                        </Col>
                        <Col className="project-content order-md-1 order-2">
                            <div className="project-desc">
                                <h3>20</h3>
                                <h5>Restaurant Website</h5>
                                <div className="project-tags">
                                    <p>Wordpress</p>
                                    <p>Elementor Pro</p>
                                </div>
                                <p>
                                    This project is a WordPress website for a USA-based restaurant
                                    chain with four separate outlets, each maintained under one domain
                                    as subdomains. Built with Elementor, the site features individual
                                    pages for each outlet, showcasing their unique menus, locations,
                                    and contact details. This centralized platform ensures consistent
                                    branding while providing tailored information for each restaurant.
                                </p>
                                <a
                                    href="https://indiapalacemn.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <BoxArrowUpRight color="white" size={"30px"} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
            <div className="text-center show-btn">
                <Button onClick={toggleShowMore}>
                    {showMore ? 'Show Less ↑' : 'Show More ↓'}
                </Button>
            </div>
        </Container>
    );
};

export default Projects;
